import { axios } from "@root/libs/axios";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

type ResponseDataType = {
  status: boolean;
};

type HandleLineConsultButtonParams = {
  workCode: string;
  lineUrl: string;
  createHistoryUrl: string;
  clientShopId?: string | number; // 求人・ブランド・企業詳細ではnumber、店舗詳細ではstringが返ってくるため
};

export const useLineConsultButton = (): {
  handleClickLineConsultButton: (params: HandleLineConsultButtonParams) => void;
} => {
  const handleClickLineConsultButton = ({
    workCode,
    lineUrl,
    createHistoryUrl,
    clientShopId,
  }: HandleLineConsultButtonParams): void => {
    const params = {
      code: workCode,
      // clientShopIdがある場合のみ、文字列にしてパラメータに追加する。
      ...(clientShopId && { clientShopId: String(clientShopId) }),
    };

    // 発火させたユーザーを記録するため。RMの/line_button_historiesで確認可能。
    axios
      .post<ResponseDataType>(createHistoryUrl, params)
      .then((res) => {
        if (!res.data.status) {
          sendErrorLog(new Error("LINE相談ボタンを押したユーザーのPOSTに失敗しました。"));
        }
      })
      .catch((error: unknown) => {
        sendErrorLog(
          error instanceof Error
            ? error
            : new Error("LINE相談ボタンを押したユーザーのPOSTに失敗しました。"),
        );
      });
    window.open(lineUrl);
  };

  return { handleClickLineConsultButton };
};
